import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { Sun, Moon } from 'lucide-react';

const ThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="relative w-14 h-7 rounded-full bg-gray-200 dark:bg-gray-700 transition-colors duration-500 focus:outline-none focus:ring-2 focus:ring-black dark:focus:ring-white focus:ring-offset-2 dark:focus:ring-offset-gray-900"
      aria-label="Toggle dark mode"
    >
      {/* Track icons */}
      <div className="absolute inset-0 flex items-center justify-between px-1.5">
        <Sun size={14} className="text-yellow-500 opacity-50" />
        <Moon size={14} className="text-blue-300 opacity-50" />
      </div>
      
      {/* Sliding circle */}
      <div
        className={`absolute top-0.5 w-6 h-6 rounded-full bg-white dark:bg-gray-900 shadow-md transform transition-all duration-500 ease-out flex items-center justify-center ${
          isDark ? 'translate-x-7' : 'translate-x-0.5'
        }`}
      >
        {isDark ? (
          <Moon size={14} className="text-blue-400 animate-spin-slow" />
        ) : (
          <Sun size={14} className="text-yellow-500 animate-spin-slow" />
        )}
      </div>
    </button>
  );
};

export default ThemeToggle;
